import {
  post, put, remove, get, getWithParams,
} from '@/services/api.service';

const state = {
  debitNotes: [],
  totalNotes: 0,
  mainTableHeaders: [
    { text: 'Nr noty', value: 'number' },
    { text: 'Odbiorca', value: 'recipient_display', sortable: false },
    { text: 'NIP', value: 'recipient_nip', sortable: false },
    { text: 'Data wystawienia', value: 'issued_at' },
    { text: 'Termin zapłaty', value: 'due_date', sortable: false },
    { text: 'Kwota', value: 'total_amount' },
    { text: 'Metoda płatności', value: 'payment_method', sortable: false },
    { text: 'Vouchery', value: 'voucher_count', sortable: false },
    { text: 'Akcje', sortable: false, align: 'center', value: 'action' },
  ],
};

const mutations = {
  setNotes(data, payload) {
    data.debitNotes = payload.data;
    data.totalNotes = payload.meta.total;
  },
};

const getters = {
  getDebitNotesList: data => data.debitNotes,
  getTotalNotes: data => data.totalNotes,
  getDebitNotesTableHeaders: data => data.mainTableHeaders,
};

const actions = {
  fetchNotes(context, payload) {
    return new Promise((resolve) => {
      getWithParams('/debit-notes', payload || {})
        .then((response) => {
          context.commit('setNotes', response);
          resolve();
        });
    });
  },
  fetchMeta(context, payload) {
    return new Promise((resolve) => {
      getWithParams('/debit-notes/meta', payload || {})
        .then((response) => {
          resolve(response);
        });
    });
  },
  fetchAvailableVouchers(context, payload) {
    return new Promise((resolve) => {
      getWithParams('/debit-notes/available-vouchers', payload || {})
        .then((response) => {
          resolve(response);
        });
    });
  },
  // wyszukanie istniejących not do pickera "Dodaj do noty" — bez zapisu do stanu listy
  searchNotes(context, payload) {
    return new Promise((resolve) => {
      getWithParams('/debit-notes', payload || {})
        .then((response) => {
          resolve(response);
        });
    });
  },
  attachVoucherToNote(context, payload) {
    return new Promise((resolve, reject) => {
      post(`/debit-notes/${payload.noteId}/vouchers/${payload.voucherId}`)
        .then(() => { resolve(); }, () => { reject(); });
    });
  },
  fetchAvailableVoucher(context, id) {
    return new Promise((resolve, reject) => {
      get(`/debit-notes/available-vouchers/${id}`)
        .then((response) => { resolve(response); }, () => { reject(); });
    });
  },
  createNote(context, payload) {
    return new Promise((resolve, reject) => {
      post('/debit-notes', payload)
        .then(() => { resolve(); }, () => { reject(); });
    });
  },
  fetchNoteDetails(context, payload) {
    return new Promise((resolve) => {
      get(`/debit-notes/${payload}`)
        .then((response) => { resolve(response); });
    });
  },
  updateNote(context, payload) {
    return new Promise((resolve, reject) => {
      put(`/debit-notes/${payload.id}`, payload)
        .then(() => { resolve(); }, () => { reject(); });
    });
  },
  removeNote(context, payload) {
    return new Promise((resolve) => {
      remove(`/debit-notes/${payload.id}`)
        .then(() => {
          context.dispatch('fetchNotes', payload.searchObj);
          resolve();
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
